import React, { FC } from 'react';
import { useQuery } from 'react-query';
import { Typography } from '@mui/material';
import CommentForm from './CommentForm';
import { Comment } from '../../lib/interfaces/Comment';
import { createComment, getTaskComments } from '../../api/apis';
import Loader from '../Simple/Loader/Loader';
import CommentSingle from './CommentSingle';
import './Comments.scss';
import { hour } from '../../lib/helpers/time.helper';

type CommentsProps = {
	taskId: number;
};

const Comments: FC<CommentsProps> = ({ taskId }) => {
	const { data, error, isLoading, refetch } = useQuery<Comment[], Error>(
		[`comments-${taskId}`],
		() => getTaskComments(taskId),
		{
			staleTime: hour,
		},
	);

	// if (isLoading) {
	// return <Loader />;
	// }

	const commentsList = data ? (
		data?.map((comment) => (
			<div key={comment.id}>
				<CommentSingle
					data={comment}
					currentTaskId={taskId}
					refetchComments={refetch}
				/>
				<div style={{ paddingLeft: '30px' }}>
					{comment.children?.map((child) => (
						<CommentSingle
							key={child.id}
							data={child}
							currentTaskId={taskId}
							parentComment={comment}
							refetchComments={refetch}
						/>
					))}
				</div>
			</div>
		))
	) : (
		<div>{error?.message}</div>
	);
	return (
		<div className="Comments">
			<Typography variant="h5" component="h5">
				Comments
			</Typography>
			<div>{isLoading ? <Loader /> : commentsList}</div>
			<CommentForm
				currentTaskId={taskId}
				mutationFn={createComment}
				refetchComments={refetch}
			/>
		</div>
	);
};

export default Comments;
